import React, { FC, PropsWithChildren, useState } from "react";

import { Box, Field, Flex, Icon } from "@chakra-ui/react";
import { LuInfo } from 'react-icons/lu';
import { useTheme } from "@emotion/react";

interface FormFieldProps {
  label?: string;
  error?: string;
  isRequired?: boolean;
  information?: string;
}

const FieldErrorText = Field.ErrorText as FC<
  PropsWithChildren<Record<string, unknown>>
>;
const FieldLabel = Field.Label as FC<PropsWithChildren>;
const FieldHelperTextSlot = Field.HelperText as FC<
  PropsWithChildren<{ mb?: string; mt?: string }>
>;

export const FormField: FC<PropsWithChildren<FormFieldProps>> = ({
  error,
  children,
  label,
  isRequired = false,
  information,
}) => {
  const [helpTextVisible, setHelpTextVisible] = useState(false);
  const theme = useTheme();
  return (
    <Field.Root invalid={Boolean(error)} mb="4">
      <Flex alignItems="center" mb={helpTextVisible ? "0" : "2"}>
        {label && (
          <FieldLabel>
            <Box as="span" display="inline-flex" alignItems="center" mr="1" mb="0">
              {label}
              {isRequired && (
                <Box
                  as="span"
                  style={{ color: error ? "#E53E3E" : undefined, marginLeft: "2px" }}
                >
                  *
                </Box>
              )}
            </Box>
          </FieldLabel>
        )}
        {information && (
          <Icon
            as={LuInfo}
            color={theme.colors.text.tertiary}
            onClick={() => setHelpTextVisible(!helpTextVisible)} />
        )}
      </Flex>
      {helpTextVisible && (
        <FieldHelperTextSlot mb="2" mt="0">
          <Box as="span">{information}</Box>
        </FieldHelperTextSlot>
      )}
      {children}
      {error && <FieldErrorText>{error}</FieldErrorText>}
    </Field.Root>
  );
};
